<script lang="ts" setup>
import { computed } from 'vue';
import AtaTableInvoicingOk from '../AtaTableInvoicingOk.vue';
import type { UseAtaTableInvoicingOkLogicProps } from '../types';
import AtaTableInvoicingOkSkeleton from './AtaTableInvoicingOkSkeleton.vue';
import { useAtaTableInvoicingOkData } from './useAtaTableInvoicingOkData';

export type AtaTableInvoicingOkDataProps = { projectId: string };

const props = defineProps<AtaTableInvoicingOkDataProps>();

const { data, isLoading } = useAtaTableInvoicingOkData(() => props.projectId);

const componentProps = computed<UseAtaTableInvoicingOkLogicProps>(() => ({
  initialAtas: (data.value ?? []).map((ata) => ({
    id: ata.id,
    amount: ata.totalCost ?? 0,
    name: ata.title,
    number: ata.serialNumber ?? 1,
    doneDate: ata.answerReceivedDate
      ? new Date(ata.answerReceivedDate)
      : undefined,
    type: ata.type ?? '',
    comment: undefined,
  })),
  projectId: props.projectId,
}));
</script>

<template>
  <AtaTableInvoicingOkSkeleton v-if="isLoading" />
  <AtaTableInvoicingOk v-else v-bind="componentProps" />
</template>
